module.exports = __webpack_public_path__ + "static/media/6.7c4f8986.jpg";